import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Получение данных карт оопт для vueLayers
  getOopt (ooptId) {
    return axios.get(`${i18n.locale}/api/public/map/oopt/${ooptId}`)
  },
  getOoptLayers (ooptId) {
    return axios.get(`${i18n.locale}/api/public/map/ooptLayers/${ooptId}`)
  },
  getFaunaLayers (faunaId) {
    return axios.get(`${i18n.locale}/api/public/map/faunaLayers/${faunaId}`)
  },
  getAllOoptLayers (type) {
    let filter = ''
    if (type) {
      filter = `type=${type}`
    }

    return axios.get(`${i18n.locale}/api/public/map/allOoptLayers?${filter}`)
  },
  getOoptMapLayerItems (ooptId) {
    return axios.get(`${i18n.locale}/api/public/map/getOoptMapLayerItems/${ooptId}`)
  }
}
